import { OfficeListMember } from '../../../../components/Contact';

export function TBMContactOffices() {
  return <OfficeListMember />;
}
